import { Outlet } from 'react-router-dom';

const ReferralsDashboardContainer = () => {
  return <Outlet />;
};

export default ReferralsDashboardContainer;
